<script>
import HeaderView from '../../../shared/views/HeaderView';
import MainMenuInstructorView from '../../../shared/views/MainMenuInstructorView';
import ListInstructorsNotificationsView from '../../views/lists/ListInstructorsNotificationsView';

export default {
  components: {
    'header-view': HeaderView,
    'main-menu-instructor-view': MainMenuInstructorView,
    'list-instructors-notifications-view': ListInstructorsNotificationsView,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<template>
  <div>
    <header-view />
    <main-menu-instructor-view />
    <!-- Body Start -->
    <list-instructors-notifications-view />
    <!-- Body End -->
  </div>
</template>